import { enMessages } from './languages/EN.lang';
import { plMessages } from './languages/PL.lang';

export const compensaTranslations = {
  pl: plMessages,
  en: enMessages,
};
